let count = 0;
const MAX_COUNT = Number.MAX_SAFE_INTEGER - 1;

export default (prefix) => {
    count = (count + 1) % MAX_COUNT;
    return `${prefix}${count}`;
};
